import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { LoadingContainer } from 'components/generic/ContentLoadingIndicator/styles'

const ContentLoadingIndicator = ({
  isLoading,
  children = null,
  size = '4x',
  color = 'gray',
  ...rest
}) => {
  return isLoading ? (
    <LoadingContainer {...rest}>
      <FontAwesomeIcon icon={faSpinner} size={size} color={color} spin />
    </LoadingContainer>
  ) : (
    children
  )
}

export default ContentLoadingIndicator
